import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { RemissionChartModel } from 'src/app/models/charts/rental/remission-chart.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { RemissionPrintModel } from 'src/app/models/print/rental/remission-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceRemissionTableModel } from 'src/app/models/tables/rental/invoice-remission-table.model';
import { RemissionTableModel } from 'src/app/models/tables/rental/remission-table.model';
import { environment } from './../../../environments/environment';
import { RemissionModel } from './../../models/rental/remission.model';

@Injectable({
  providedIn: 'root'
})
export class RemissionService {

  constructor(private _httpClient: HttpClient) { }

  attachFilesToRemission(remissionId: number, files: FormData): Observable<Array<string>> {
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.AttachFilesToRemission}/${remissionId}`, files);
  }

  deleteFilesToRemission(remissionId: number, file: string): Observable<Array<string>> {
    const itemFilterResponse = new ItemFilterModel("file", null, remissionId, file);
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.DeleteFilesToRemission}`, itemFilterResponse);
  }

  downloadFileToRemission(remissionId: number, file: string): Observable<HttpEvent<Blob>> {
    const itemFilterResponse = new ItemFilterModel("file", null, remissionId, file);
    return this._httpClient.request(new HttpRequest('POST', `${environment.apiCervinoBackend}${enpointCervinoWeb.remission.DownloadFileToRemission}`,
      itemFilterResponse, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, timeZoneId: string): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('timeZoneId', timeZoneId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportInvoiceForRemissionConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.ExportInvoiceForRemissionConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getFilesToRemission(remissionId: number): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetFilesToRemission}/${remissionId}`,
    );
  }

  getAllCostCenterForSelect(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllCostCenterForSelectAsync}/${branchId}`);
  }

  getAllTransporterForSelect(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllTransporterForSelectAsync}/${branchId}`);
  }

  getAllVehicleForSelect(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllVehicleForSelectAsync}/${branchId}`);
  }

  getAllUsersAppForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllUsersAppForSelectAsync}`);
  }

  getAllConceptsRequirementTypeForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllConceptsRequirementTypeForSelectAsync}`);
  }

  getAllConceptsDelayReasonForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllConceptsDelayReasonForSelectAsync}`);
  }

  getAllConceptsTypeAvailabilityForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllConceptsTypeAvailabilityForSelectAsync}`);
  }


  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetColumnsForGeneralConsultation}`);
  }

  getColumnsForInvoiceConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetColumnsForInvoiceConsultation}`);
  }

  getRemissionById(remissionId: number): Observable<RemissionModel> {
    return this._httpClient.get<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetRemissionById}/${remissionId}`);
  }

  createRemission(remissionModel: RemissionModel): Observable<RemissionModel> {
    return this._httpClient.post<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.CreateRemission}`,
      remissionModel);
  }

  updateRemission(remissionContract: RemissionModel): Observable<RemissionModel> {
    return this._httpClient.put<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.UpdateRemission}`,
      remissionContract);
  }

  deleteRemission(remissionId: number): Observable<RemissionModel> {
    return this._httpClient.delete<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.DeleteRemission}/${remissionId}`);
  }

  setStateRemission(remissionId: number): Observable<RemissionModel> {
    return this._httpClient.put<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.SetStateRemission}/${remissionId}`,
      null);
  }

  annulRemission(remissionId: number): Observable<RemissionModel> {
    return this._httpClient.put<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.AnnulRemission}/${remissionId}`,
      null);
  }

  blockRemission(remissionId: number): Observable<RemissionModel> {
    return this._httpClient.put<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.BlockRemission}/${remissionId}`,
      null)
  }

  getPermissionPrint(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetPermissionPrint}`);
  }

  updateStatePrintRemission(remissionId: number): Observable<RemissionModel> {
    return this._httpClient.put<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.PrintRemission}/${remissionId}`,
      null)
  }

  getAllInvoiceForRemissionsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InvoiceRemissionTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<InvoiceRemissionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllInvoiceForRemissionsWithPagination}`,
      filters, { params: params }
    );
  }

  getAllRemissionsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RemissionTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RemissionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetAllRemissionsWithPagination}`,
      filters, { params: params }
    );
  }

  getRemissionByKeysAsync(branchId: number, consecutive: number): Observable<RemissionModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetRemissionByKeys}`,
      { params: params });
  }

  getFirstRemissionByKeysAsync(branchId: number): Observable<RemissionModel> {
    return this._httpClient.get<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetFirstRemissionByKeys}/${branchId}`);
  }

  getIndicatorsForGeneralConsultation(filters: ColumnResponseModel[]): Observable<RemissionChartModel> {
    return this._httpClient.post<RemissionChartModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetIndicatorsForGeneralConsultationAsync}`,
      filters
    );
  }

  getLastRemissionByKeysAsync(branchId: number): Observable<RemissionModel> {
    return this._httpClient.get<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetLastRemissionByKeys}/${branchId}`);
  }

  getPreviusRemissionByKeysAsync(branchId: number, consecutive: number | null): Observable<RemissionModel> {
    let params = new HttpParams().set('branchId', branchId)
    if (consecutive !== null)
      params = params.set('consecutive', consecutive.toString());
    return this._httpClient.get<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetPreviusRemissionByKeys}`,
      { params: params });
  }

  getNextRemissionByKeysAsync(branchId: number, consecutive: number | null): Observable<RemissionModel> {
    let params = new HttpParams().set('branchId', branchId)
    if (consecutive !== null)
      params = params.set('consecutive', consecutive.toString());
    return this._httpClient.get<RemissionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetNextRemissionByKeys}`,
      { params: params });
  }

  getRemissionConsecutiveByIdAsync(remissionId: number): Observable<number> {
    return this._httpClient.get<{ value: number }>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetRemissionConsecutiveByIdAsync}/${remissionId}`)
      .pipe(map(response => response.value));
  }

  getEmptyRemissionPrint(): Observable<RemissionPrintModel> {
    return this._httpClient.get<RemissionPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetEmptyRemissionPrint}`);
  }

  getRemissionByKeysByPrint(branchId: number, consecutive: number, remissionId: number): Observable<RemissionPrintModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive).set('remissionId', remissionId)
    return this._httpClient.get<RemissionPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.GetRemissionByKeysByPrint}`,
      { params: params });
  }

  hasExistingRemission(branchId: number): Observable<boolean> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remission.HasExistingRemissionAsync}`,
      { params: params }
    );
  }
}
